import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_admin/a/plugins/$pluginId/")({
    component: RouteComponent,
});

/** Redirects to the default tab */
function RouteComponent() {
    const params = Route.useParams();
    return <Navigate to={"/a/plugins/$pluginId/rulesets"} params={params} replace />;
}
